(function () {
    "use strict";

    angular.module("services")
        .service("NotificationsPlatformService", NotificationsPlatformService);

    NotificationsPlatformService.$inject = ["$http", "API_BASE", "$q"];

    function NotificationsPlatformService($http, API_BASE, $q) {
        var service = this;

        service.getAllExpos = getAllExpos;
        service.getExhibitors = getExhibitors;
        service.sendNotification = sendNotification;
        service.getAllNotifications = getAllNotifications;
        service.saveGeneralNotifications = saveGeneralNotification;
        service.getAllGeneralNotifications = getAllGeneralNotifications;

        function getAllExpos(query) {
            return $http.get(API_BASE + "/virtualfairs/list", { params: query });
        }

        function getAllNotifications(id) {
            return $http.get(API_BASE + `/notifications/fair/${id}/list`);
        }

        function getExhibitors(id) {
            return $http.get(API_BASE + `/notifications/fair/${id}/expos`);
        }

        function sendNotification(payload){
            return $http.post(API_BASE + "/notifications", payload)
        }

        function saveGeneralNotification(payload){
            return $http.post(API_BASE + "/notifications/general", payload)
        }

        function getAllGeneralNotifications(){
            return $http.get(API_BASE + "/notifications/general");
        }
    }
})();
